import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useRouteMatch } from "react-router-dom";
import allActions from "../actions/allActions";
import { BreadCrumb } from "../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../components/breadcrumbs/BreadRoute";
import { Card } from "../components/utils/Card";
import { EventParamTypes } from "../types/types";
import * as eState from "./eventReducer";

export const SubEventContainer: React.FC = () => {
  const { id, subEventId } = useParams<EventParamTypes>();
  const hasForm = useSelector(eState.selectHasSubEventForm);
  const dispatch = useDispatch();
  const { eventDetailsFetched, eventListFetched } = useSelector(
    eState.selectDataFetchedFlags
  );
  let { url } = useRouteMatch();
  const linkParagraphId = hasForm
    ? "SubEvent.Card.Link"
    : "SubEvent.Card.Link.NoRegistration";
  const registrationParagraphId = hasForm
    ? "SubEvent.Card.Registration"
    : "SubEvent.Card.Registration.NoRegistration";

  const getEventDetails = useCallback(() => {
    if (!eventDetailsFetched) {
      dispatch(allActions.eventActions.startGetEventDetails(id));
    }
  }, [eventDetailsFetched, id, dispatch]);

  const getAllEvents = useCallback(() => {
    if (!eventListFetched) {
      dispatch(
        allActions.eventActions.getAllEvents({ date: "0", limit: "100" })
      );
    }
  }, [eventListFetched, dispatch]);

  const getSubEventDetails = useCallback(() => {
    dispatch(allActions.eventActions.getSubEventDetails(subEventId));
  }, [subEventId, dispatch]);

  useEffect(() => {
    getAllEvents();
  }, [getAllEvents]);

  useEffect(() => {
    getEventDetails();
  }, [getEventDetails]);

  useEffect(() => {
    getSubEventDetails();
  }, [getSubEventDetails]);

  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb label={`event ${id} `} link={`/events/${id}`} />
        <BreadCrumb label={`subevents`} link={`/events/${id}/subevents/`} />
        <BreadCrumb
          label={`subevent ${subEventId}`}
          link={`${url}`}
          lastChild={true}
        />
      </BreadRoute>
      <div className='container h-full max-h-11/12 w-full flex justify-center'>
        <Card
          header='SubEvent.Card.Registration.Header'
          paragraph={registrationParagraphId}
          link={`${url}/registration`}
          linkStr={"Navigation.SubEvent_Registration"}
          image='img/43946.jpg'
          canClick={true}
        />
        <Card
          header='SubEvent.Card.Link.Header'
          paragraph={linkParagraphId}
          link={`${url}/link`}
          linkStr={"Navigation.SubEvent_Link"}
          image='img/64621.jpg'
          canClick={hasForm}
        />
      </div>
    </div>
  );
};

export default SubEventContainer;
